import ContentBox from '~/components/ContentBox';

import AddPlan from './index';

export default function AddPlanSection({ title, user, segment }) {
  return (
    <ContentBox.Group>
      <ContentBox.Section>
        <AddPlan title={title} user={user} segment={segment} />
      </ContentBox.Section>
    </ContentBox.Group>
  );
}
